import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22brand.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/zen-maru-gothic-tamariba-700.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:true,%22adjustFontFallback%22:false,%22fallback%22:[%22sans-serif%22]}],%22variableName%22:%22wordmarkFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'wordmarkFont', sans-serif",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
